(() => {
  const root = document.querySelector('[data-bnf-origano-editorial]');
  if (!root) return;
  // Keep paid-campaign attribution when a reader continues to the product.
  const incoming = new URLSearchParams(location.search);
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term'];
  const attribution = attributionKeys.filter(key => incoming.get(key));
  if (attribution.length) root.querySelectorAll('a[data-boe-cta]').forEach(link => {
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !destination.pathname.startsWith('/products/')) return;
    attribution.forEach(key => destination.searchParams.set(key, incoming.get(key)));
    link.href = destination.href;
  });
  root.querySelector('[data-copy-boe]')?.addEventListener('click', async () => {
    const status = root.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(`${location.origin}${location.pathname}`);
      status.textContent = 'Link copiato';
    } catch {
      status.textContent = 'Copia l’indirizzo dalla barra del browser';
    }
  });
})();
